var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCirculation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 290",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#Sfumatura_senza_nome_12);\n      }\n\n      .cls-1, .cls-2 {\n        mix-blend-mode: multiply;\n      }\n\n      .cls-3 {\n        fill: #9da4b0;\n      }\n\n      .cls-4 {\n        isolation: isolate;\n      }\n\n      .cls-2 {\n        fill: url(#Sfumatura_senza_nome_12-2);\n      }\n\n      .cls-5 {\n        fill: #039687;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_12",
    "data-name": "Sfumatura senza nome 12",
    x1: 107.9,
    y1: 243.3,
    x2: 107.9,
    y2: 47.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_12-2",
    "data-name": "Sfumatura senza nome 12",
    x1: 159.1,
    y1: 46.7,
    x2: 159.1,
    y2: 94.1,
    xlinkHref: "#Sfumatura_senza_nome_12"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M200,290h-112.6s-35.1-34.5-35.1-34.5V86.1s40.2-39.5,40.2-39.5h107.4v47.4h-95.2s0,148.7,0,148.7h95.2v47.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "116.7 0 0 0 0 243.3 52.3 243.3 52.3 202.1 52.3 195.5 52.3 47.4 104.4 47.4 104.4 195.5 104.4 202.1 104.4 243.3 121.8 243.3 156.9 208.9 156.9 39.5 116.7 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "104.4 47.4 104.4 243.3 111.5 243.3 104.4 47.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "156.9 94.1 156.9 46.7 161.3 46.7 156.9 94.1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirculation);
export default __webpack_public_path__ + "static/media/circulation.f04e3c604c38c86e493fc91511fc06d8.svg";
export { ForwardRef as ReactComponent };